if (!customElements.get('js-sticky-atc')) {
  customElements.define(
    'js-sticky-atc',
    class JsStickyAtc extends HTMLElement {
      connectedCallback() {
        this.mainButton = document.querySelector('product-info .product-form__submit');
        this.button = this.querySelector('button');
        if (!this.mainButton || !this.button) return;

        this.button.addEventListener('click', () => this.mainButton.click());

        // Show whenever the real button is off screen, above or below. Long color lists push the
        // button down on phones, so the bar keeps the buy action within reach while choosing.
        this.observer = new IntersectionObserver(([entry]) => {
          const visible = !entry.isIntersecting;
          this.classList.toggle('is-visible', visible);
          this.setAttribute('aria-hidden', String(!visible));
          this.button.tabIndex = visible ? 0 : -1;
        });
        this.observer.observe(this.mainButton);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => this.update(data));
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.unsubscribe) this.unsubscribe();
      }

      update({ variant, html, sectionId }) {
        if (!variant) return;
        const title = this.querySelector('[data-variant-title]');
        if (title) title.textContent = variant.title;

        const price = this.querySelector('[data-price]');
        const source = html && html.getElementById(`price-${sectionId}`);
        const sourcePrice = source && source.querySelector('.price-item--sale, .price-item--regular');
        if (price && sourcePrice) price.textContent = sourcePrice.textContent.trim();

        this.button.disabled = !variant.available;
        this.querySelector('[data-label-available]').hidden = !variant.available;
        this.querySelector('[data-label-sold-out]').hidden = variant.available;
      }
    }
  );
}
